import { BOARD_RELATIONSHIP_KINDS, type BoardRelationshipKind } from "@chessla/shared";
import type { ReviewBoardSettings, ReviewBoardSettingsPatch } from "../review-board-settings";
import { positionRelationships } from "./teaching-explainer";

/** Whether a relationship kind is switched on, including the older Pins and Support group switches. */
export const relationshipEnabled = (settings: ReviewBoardSettings, kind: BoardRelationshipKind) =>
  !settings.hiddenRelationships.includes(kind) &&
  (kind === "pin" || kind === "relative_pin"
    ? settings.markerGroups.pin
    : kind === "support"
      ? settings.markerGroups.support
      : true);

/** Flips one kind; the group switches are folded into the per-kind list so every kind toggles on its own. */
export const toggleRelationship = (
  settings: ReviewBoardSettings,
  kind: BoardRelationshipKind,
): ReviewBoardSettingsPatch => ({
  markerGroups: { pin: true, support: true },
  hiddenRelationships: BOARD_RELATIONSHIP_KINDS.filter((candidate) =>
    candidate === kind ? relationshipEnabled(settings, candidate) : !relationshipEnabled(settings, candidate),
  ),
});

export const boardPositionMarkers = (fen: string, settings: ReviewBoardSettings, focusSquare?: string | null) => {
  if (!settings.showPositionMarkers) return [];
  return positionRelationships(fen).filter((marker) => {
    if (settings.hiddenRelationships.includes(marker.kind)) return false;
    if (marker.kind === "pin" || marker.kind === "relative_pin") return settings.markerGroups.pin;
    if (marker.kind === "support")
      return settings.markerGroups.support && (settings.showAllPositionMarkers || marker.to === focusSquare);
    if (marker.kind === "xray" || marker.kind === "discovered_potential")
      return (
        settings.showTacticalMotifs &&
        (settings.showAllPositionMarkers || [marker.from, marker.subject, marker.to].includes(focusSquare ?? ""))
      );
    return settings.showTacticalMotifs;
  });
};
